<div class="flex flex-col pt-[24px] pb-[48px] border rounded-2xl w-[375px] bg-white shadow-[0px_20px_35px_0px_rgba(0,0,0,0.20)]">
  <div class="px-[15px] flex flex-col">
    <div class="text-lg font-bold text-cafe">
      {{'labels.orderSummary' | transloco}}
    </div>
    <div class="grid grid-cols-2 text-base font-normal mt-[25px] mb-[15px]">
      <div class="text-cafe">
        {{'labels.subTotal' | transloco}}
      </div>
      <div class="text-cafe text-base font-normal text-end">
        $ {{subTotal | number:'1.0-0'}} <span class="text-sm">USD</span>
      </div>
    </div>
    <div class="justify-start text-verde text-base font-normal">{{'labels.shippingCostPending' | transloco}}</div>
    @if(singleProductAlert) {
      <div class="w-80 mt-[17px] justify-start text-naranja text-base font-normal font-['Roboto']">{{'messages.productsPendingAvailabilityNotIncluded' | transloco}}.</div>
    }

  </div>
  <div class="mt-[15px] mb-[20px] border-b border-b-grisTinku"></div>
  <div class="px-[15px] grid grid-cols-2 text-base text-cafe font-bold mb-[35px]">
    <div>
      {{'labels.totalBeforeShipping' | transloco}}
    </div>
    <div class="text-end">
      $ {{subTotal | number:'1.0-0' }} <span class="text-sm">USD</span>
    </div>
  </div>
  <div class="px-[15px]">
    <ln-primary-button [label] = "'buttons.purchaseQuote' | transloco" [class]="'flex w-full bg-[#577778] text-base font-semibold text-white pt-[15px] pb-[14px] rounded-md justify-center'"
    (OnClick)="navigateToPurchaseCompletion()"
    ></ln-primary-button>
  </div>
</div>
